import axios from "axios";
const BaseURL = process.env.REACT_APP_BASEURL;


export const getProducts = async (page = 1, per_page = 10) => {
    try {
        const response = await axios.post(
            `${BaseURL}/product/product/plists_optimized/`,
            {
                page,
                per_page
            },
            {
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response;
    } catch (error) {
        console.error(error);
    }
};
  
// promotions 
export const createPromotions = async (data) => {
    try {
        const response = await axios.post(
            `${BaseURL}/product/promotions/`,
            data,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response;
    } catch (error) {
        console.error('error in promotions:', error);
    }
};
export const fetchPromotions = async (data) => {
    try {
        const response = await axios.get(
            `${BaseURL}/product/promotions/`,

            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,

                }
            }
        );
        return response;
    } catch (error) {
        console.error('error in promotions:', error);
    }
};

export const deletePromotion = async (id) => {
    try {
        const response = await axios.delete(
            `${BaseURL}/product/promotions/${id}/`,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response;
    } catch (error) {
        console.error('error deleting promotion:', error);
    }
};

export const editPromotions = async (id, data) => {
    try {
        const response = await axios.patch(
            `${BaseURL}/product/promotions/${id}/`,
            data,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response;
    } catch (error) {
        console.error('error editing promotion:', error);
    }
};

// ----------------------------------

//choose by department

export const createDepartment = async (data) => {
    try {
        const response = await axios.post(
            `${BaseURL}/product/department-offers/`,
            data,
            {
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response;
    } catch (error) {
        console.error('error creating department:', error);
    }
};

export const fetchDepartments = async () => {
    try {
        const response = await axios.get(
            `${BaseURL}/product/department-offers/`,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response;
    } catch (error) {
        console.log(error);
    }
};

export const updateDepartments = async (id, data) => {
    try {
        const response = await axios.patch(
            `${BaseURL}/product/department-offers/${id}/`,
            data,
            {
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response;
    } catch (error) {
        console.error('error updating department:', error);
    }
};

export const deleteDepartment = async (id) => {
    try {
        const response = await axios.delete(
            `${BaseURL}/product/department-offers/${id}/`,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response;
    } catch (error) {
        console.error('error deleting department:', error);
    }
};

//------------------------------------------------------------

// best offers 
export const createBestOffers = async (data) => {
    try {
        const response = await axios.post(
            `${BaseURL}/product/best-offers/`,
            data,
            {
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response;
    } catch (error) {
        console.error('error creating best offer:', error);
    }
};


export const fetchBestOffers = async () => {
    try {
        const response = await axios.get(
            `${BaseURL}/product/best-offers/group_wise/`,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response;
    } catch (error) {
        console.error('error fetching best offers:', error);
    }
};

export const updateBestOffers = async (id, data) => {
    try {
        const response = await axios.patch(
            `${BaseURL}/product/best-offers/${id}/`,
            data,
            {
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response;
    } catch (error) {
        console.error('error updating best offer:', error);
    }
};

export const deleteBestOffers = async (id) => {
    try {
        const response = await axios.delete(
            `${BaseURL}/product/best-offers/${id}/`,
            {
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Token ${localStorage.getItem('adminAuth')}`,
                }
            }
        );
        return response;
    } catch (error) {
        console.error('error deleting best offer:', error);
    }
};